<style>
.unique_equipment {
    margin-left: auto;
    margin-right: auto;
    max-width: 677px;
    display: block;
    padding-top: 10px;
    box-sizing: border-box;
    height: auto;
    background: #FFFFFF;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
    min-width: 300px;
    margin-top: 33px;
}
.ue_lineup {
    font-family: Gotham Pro, sans-serif;
    font-style: normal;
    font-weight: normal;
    color: #404455;
    font-size: 16px;
    line-height: 15px;
    text-align: left;
}
.ue_info_wrap {
    padding-left: 5%;
    padding-right: 5%;
}
.ue_info_wrap:after {
    content: "";
    display: block;
    clear: both;
}
.ue_info {
    padding-top: 15px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}
.ue_left ul li:first-child, .ue_left ul li:nth-child(2){
    font-weight:500;
    letter-spacing: 0.1em;
}
.ue_left ul li{
    padding-bottom: 19px;
}
.ue_right ul{
    margin: 0;
    padding: 0;
    list-style:none;
    font-family: Gotham Pro, sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 10px;
    color: #404455;
    padding-left: 3%;
}
.ue_left ul{
    margin: 0;
    padding: 0;
    list-style: none;
    font-family: Gotham Pro, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    color: #404455;
    letter-spacing: 0.014em;

}
.ue_left{
    min-width: 250px;
    flex: 1;
}
.ue_right {
    text-align: center;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.ue_container{
    width: 120px;
    height: 50px;
    border: 1px solid #FF0000;
    box-sizing: border-box;
    border-radius: 5px;
    display: flex;
    text-align: center;
    justify-content: center;
    align-content: flex-start;
    align-items: center;
    background: #FF0000;
    font-size: 16px;
    line-height: 15px;
    font-family: Gotham Pro, sans-serif;
    font-style: normal;
    font-weight: bold;
    color: #FFFFFF;
    position: relative;
    bottom: 45px;
    margin-top: 65px;
    float: right;
    transition: 0.25s;
    text-decoration: none;
}

.ue_container:hover {
    background-color: #DD0000;
    color: #FFFFFF;
}
.ue_container:active, .ue_container:focus {
    background-color: #ff0000;
    color: #FFFFFF;
    box-shadow: 0 0 0 0.2rem #ff000060;
}
.ue_container_prev{
    float: left;
    background-color: #FFFFFF;
    color: #FF0000;
}
.ue_container_prev{
    float: left;
    background-color: #FFFFFF;
    color: #FF0000;
}
.ue_container_prev:hover {
    background-color: #FF0000;
    color: #FFFFFF;
}
.ue_container_prev:active, .ue_container_prev:focus {
    background-color: #FF0000;
    color: #FFFFFF;
    box-shadow: 0 0 0 0.2rem #ff000060;
}
.ue_header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}
</style>
<script>

    import { mutations, track, first, goodsList} from '../mainStore.js';
    import ColorImage from './ColorImage.svelte';
    import ColorPicker from './ColorPicker.svelte';
    import TrackDescription from './TrackDescription.svelte';
    import config from '../config';
    import { onMount } from "svelte";
    onMount(() => {
        window.scrollTo(0,0)
    });
</script>
<div class="unique_equipment">
    <div class="ue_info_wrap">
        <div class="ue_header">
            <div class="ue_lineup">
                Модель {$track.name}
            </div>
            <div class="ue_right">
                <ul>
                    <li>Цвет:</li>
                </ul>
                <ColorPicker track={$track} />
            </div>
        </div>
        <ColorImage track={$track} />
        <div class="ue_info">
            <div class="ue_left">
                <TrackDescription track={$track} />
            </div>
        </div>
        <a href="#step1" class="ue_container ue_container_prev" on:click="{()=>mutations.setStep(1)}">
            Выбрать другой
        </a>
        <a href="#step3" class="ue_container ue_container_next" on:click="{()=>{
            mutations.setStep(3);
        }}">
            {#if ($goodsList.length == 0)}
                Начать сборку
            {:else}
                Продолжить сборку
            {/if}
        </a>
    </div>
</div>
